// extracted by mini-css-extract-plugin
export default {"warningIconWrapper":"DropzoneWarnings__warningIconWrapper___iMSiy"};